export const FETCH_ADMIN_RELATIONSHIPS_REQUEST = 'admin/FETCH_ADMIN_RELATIONSHIPS_REQUEST';
export const FETCH_ADMIN_RELATIONSHIPS_SUCCESS = 'admin/FETCH_ADMIN_RELATIONSHIPS_SUCCESS';

export const FETCH_SCHOOL_ADMIN_RELATIONSHIPS_REQUEST = 'admin/FETCH_SCHOOL_ADMIN_RELATIONSHIPS_REQUEST';
export const FETCH_SCHOOL_ADMIN_RELATIONSHIPS_SUCCESS = 'admin/FETCH_SCHOOL_ADMIN_RELATIONSHIPS_SUCCESS';
export const FETCH_SCHOOL_ADMIN_RELATIONSHIPS_FAILURE = 'admin/FETCH_SCHOOL_ADMIN_RELATIONSHIPS_FAILURE';

export const FETCH_MY_ADMIN_APPLICATIONS_REQUEST = 'admin/FETCH_MY_ADMIN_APPLICATIONS_REQUEST';
export const FETCH_MY_ADMIN_APPLICATIONS_SUCCESS = 'admin/FETCH_MY_ADMIN_APPLICATIONS_SUCCESS';
export const FETCH_MY_ADMIN_APPLICATIONS_FAILURE = 'admin/FETCH_MY_ADMIN_APPLICATIONS_FAILURE';

export const CREATE_ADMIN_APPLICATION_REQUEST = 'admin/CREATE_ADMIN_APPLICATION_REQUEST';
export const CREATE_ADMIN_APPLICATION_SUCCESS = 'admin/CREATE_ADMIN_APPLICATION_SUCCESS';
export const CREATE_ADMIN_APPLICATION_FAILURE = 'admin/CREATE_ADMIN_APPLICATION_FAILURE';

export const DELETE_ADMIN_RELATIONSHIP_REQUEST = 'admin/DELETE_ADMIN_RELATIONSHIP_REQUEST';
export const DELETE_ADMIN_RELATIONSHIP_SUCCESS = 'admin/DELETE_ADMIN_RELATIONSHIP_SUCCESS';
export const DELETE_ADMIN_RELATIONSHIP_FAILURE = 'admin/DELETE_ADMIN_RELATIONSHIP_FAILURE';

export const INIT_ADMIN_APPLICATION = 'admin/INIT_ADMIN_APPLICATION';

export const CLEAR_ADMIN_APPLICATION_ERROR = 'admin/CLEAR_ADMIN_APPLICATION_ERROR';

export const CLEAR_ADMIN_DELETED = 'admin/CLEAR_ADMIN_DELETED';

export const fetchAdminRelationshipsRequest = (payload = {}) => ({
  type: FETCH_ADMIN_RELATIONSHIPS_REQUEST,
  payload,
});
export const fetchAdminRelationshipsSuccess = (payload = {}) => ({
  type: FETCH_ADMIN_RELATIONSHIPS_SUCCESS,
  payload,
});

export const fetchSchoolAdminRelationshipsRequest = (payload = {}) => ({
  type: FETCH_SCHOOL_ADMIN_RELATIONSHIPS_REQUEST,
  payload,
});
export const fetchSchoolAdminRelationshipsSuccess = (payload = {}) => ({
  type: FETCH_SCHOOL_ADMIN_RELATIONSHIPS_SUCCESS,
  payload,
});
export const fetchSchoolAdminRelationshipsFailure = (payload = {}) => ({
  type: FETCH_SCHOOL_ADMIN_RELATIONSHIPS_FAILURE,
  payload,
});

export const fetchMyAdminApplicationsRequest = (payload = {}) => ({
  type: FETCH_MY_ADMIN_APPLICATIONS_REQUEST,
  payload,
});
export const fetchMyAdminApplicationsSuccess = (payload = {}) => ({
  type: FETCH_MY_ADMIN_APPLICATIONS_SUCCESS,
  payload,
});
export const fetchMyAdminApplicationsFailure = (payload = {}) => ({
  type: FETCH_MY_ADMIN_APPLICATIONS_FAILURE,
  payload,
});

export const createAdminApplicationRequest = (payload = {}) => ({
  type: CREATE_ADMIN_APPLICATION_REQUEST,
  payload,
});
export const createAdminApplicationSuccess = (payload = {}) => ({
  type: CREATE_ADMIN_APPLICATION_SUCCESS,
  payload,
});
export const createAdminApplicationFailure = (payload = {}) => ({
  type: CREATE_ADMIN_APPLICATION_FAILURE,
  payload,
});

export const deleteAdminRelationshipRequest = (payload = {}) => ({
  type: DELETE_ADMIN_RELATIONSHIP_REQUEST,
  payload,
});
export const deleteAdminRelationshipSuccess = (payload = {}) => ({
  type: DELETE_ADMIN_RELATIONSHIP_SUCCESS,
  payload,
});
export const deleteAdminRelationshipFailure = (payload = {}) => ({
  type: DELETE_ADMIN_RELATIONSHIP_FAILURE,
  payload,
});

export const initAdminApplication = (payload = {}) => ({
  type: INIT_ADMIN_APPLICATION,
  payload,
});

export const clearAdminApplicationError = (payload = {}) => ({
  type: CLEAR_ADMIN_APPLICATION_ERROR,
  payload,
});

export const clearAdminDeleted = (payload = {}) => ({
  type: CLEAR_ADMIN_DELETED,
  payload,
});
